module.exports = __webpack_public_path__ + "assets/img/11_475.8ec769ae.jpg";